import useContextMenu from 'app/app/editor/tabs/utils/useContextMenu';
import { MouseEvent, useState } from 'react';
import MenuItemPaste from 'app/app/editor/tabs/elements/layout/context-menu/MenuItemPaste';
import MenuItemDelete from 'app/app/editor/tabs/elements/layout/context-menu/MenuItemDelete';
import MenuItemCopy from 'app/app/editor/tabs/elements/layout/context-menu/MenuItemCopy';
import MenuItemCut from 'app/app/editor/tabs/elements/layout/context-menu/MenuItemCut';
import MenuItemWrap from 'app/app/editor/tabs/elements/layout/context-menu/MenuItemWrap';
import MenuAddContainer from 'app/app/editor/tabs/elements/layout/context-menu/MenuItemAddContainer';
import MenuAddMenuContainer from 'app/app/editor/tabs/elements/layout/context-menu/MenuItemAddMenuContainer';

export function useLayoutContextMenu() {
    const [openWithUid, setOpenWithUid] = useState<string>();
    const { handleOpen, contextMenu } = useContextMenu((handleClose) => {
        if (!openWithUid) {
            setTimeout(() => handleClose());
            return [];
        }

        const params = {
            handleClose: handleClose,
            openWithUid: openWithUid,
        };

        return [
            <MenuAddContainer key={'add_container'} {...params} />,
            <MenuAddMenuContainer key={'add_menu_container'} {...params} />,
            <MenuItemCut key={'cut'} {...params} />,
            <MenuItemCopy key={'copy'} {...params} />,
            <MenuItemPaste key={'paste'} {...params} />,
            <MenuItemDelete key={'delete'} {...params} />,
            <MenuItemWrap key={'wrap'} {...params} />,
        ];
    });

    const handleOpenContextMenu = (event: MouseEvent, nodeUid: string) => {
        if (!nodeUid) {
            setOpenWithUid(undefined);
            return;
        }
        setOpenWithUid(nodeUid);
        handleOpen(event);
    };

    return { handleOpenContextMenu, contextMenu };
}
